import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import styled from "styled-components";

const Wrap = styled.div`
  min-height: 100%;
  position: relative;
  ${({ checkout }) =>
    checkout &&
    `
    min-height: unset;
  `};
`;

// background-color: #f8f7f5;
const Component = ({
  children,
  right,
  classNameHeader,
  checkout,
  insiders
}) => (
  <React.Fragment>
    <Header
      insiders={insiders}
      headerDisplay={classNameHeader}
      right={<div className="v-mid tr db">{right}</div>}
    />
    <Wrap className="lh-copy" checkout>
      {children}
      <Footer />
    </Wrap>
  </React.Fragment>
);

Component.Link = ({ children, onClick }) => (
  <div onClick={onClick} className="pointer link dim dark-gray dib ml2">
    {children}
  </div>
);

Component.MenuLink = ({ children, onClick, path }) => (
  <div onClick={onClick} className="pa3 dim pointer link dark-gray center">
    {children}
  </div>
);
export default Component;



// WEBPACK FOOTER //
// ./src/components/generic/layout/Overlay/index.js